import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useLayoutEffect, useState } from 'react';
import ddt from '@wix/da-ddt';
import { useViewBlockChecks } from '../../DeviationViews/Full/hooks/useViewBlockChecks';
import { DEFAULT_MULTI_IMAGE_STAGE } from '../constants';
import DesktopMultiArtScrollStage from './DesktopMultiArtScrollStage';
import DesktopMultiArtCarouselStage from './DesktopMultiArtCarouselStage';
const logger = ddt.createLogger('multifile');
export const DesktopMultiArtStage = (props)=>{
    const { deviation } = props;
    const [displayMode, setDisplayMode] = useState(DEFAULT_MULTI_IMAGE_STAGE);
    // if disabled, only show carousel
    const { hasBlock } = useViewBlockChecks(deviation);
    const StageComponent = displayMode === 'scroll' && !hasBlock ? DesktopMultiArtScrollStage : DesktopMultiArtCarouselStage;
    const [currentlyViewedImageSource, setCurrentlyViewedImageSource] = useState(deviation);
    // when duperbrowse switches between deviations, reset to show main image
    useLayoutEffect(()=>{
        setCurrentlyViewedImageSource(deviation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deviation.deviationId
    ]);
    var _currentlyViewedImageSource_title;
    logger.log('DesktopMultiArtStage', {
        deviation: deviation.deviationId,
        displayMode,
        hasBlock,
        currentlyViewedImageSource: (_currentlyViewedImageSource_title = currentlyViewedImageSource === null || currentlyViewedImageSource === void 0 ? void 0 : currentlyViewedImageSource['title']) !== null && _currentlyViewedImageSource_title !== void 0 ? _currentlyViewedImageSource_title : currentlyViewedImageSource === null || currentlyViewedImageSource === void 0 ? void 0 : currentlyViewedImageSource['filename']
    });
    return /*#__PURE__*/ React.createElement(StageComponent, _object_spread_props(_object_spread({}, props), {
        disabled: hasBlock,
        setDisplayMode: setDisplayMode,
        currentlyViewedImageSource: currentlyViewedImageSource,
        setCurrentlyViewedImageSource: setCurrentlyViewedImageSource
    }));
};
DesktopMultiArtStage.displayName = 'DesktopMultiArtStage';
export default DesktopMultiArtStage;

//# sourceMappingURL=DesktopMultiArtStage.js.map